import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/**
The main entry point for Megafleece Hero Page.

Referenced by page.megafleece.liquid templates.
* */
import React from 'react';
import ReactDOM from 'react-dom';
import { OV_CDN } from './config/theme';
import ProductSpotlight from './components/ProductSpotlight';
/* eslint-disable max-len, no-multi-str */

import { jsx as _jsx } from "react/jsx-runtime";

var init = function init() {
  var imageRoot = "".concat(OV_CDN, "shopify/2.0.0/images/pages/megafleece/");
  var posterProps = {
    posterCta: 'Shop OV Outdoors',
    posterImage: "".concat(imageRoot, "poster.jpg"),
    posterMessage: 'Use Your <br>Outdoor Voice',
    posterUrl: '/collections/outdoors-women'
  };
  var videoProps = {
    fullVideoCaptions: "".concat(OV_CDN, "video/megafleece_full_captions.vtt"),
    fullVideoDescription: "".concat(OV_CDN, "video/megafleece_full_description.vtt"),
    fullVideoSrc: "".concat(imageRoot, "hero_video_actual.mp4"),
    previewPoster: "".concat(imageRoot, "video_poster.jpg"),
    previewSrc: "".concat(imageRoot, "hero_video_preview.mp4"),
    previewTrack: "".concat(OV_CDN, "video/megafleece_short_track.vtt")
  };
  var blends = [{
    percent: 63,
    title: 'Recycled Wool',
    description: 'This 100% recycled wool is milled in a family-owned mill in Prato, Italy that has been spinning top quality fibers for more than 60 years.',
    features: ['Naturally thermoregulating', 'Breathable', 'Anti odor'],
    showPercent: true
  }, {
    percent: 37,
    title: 'Poly-Nylon Blend',
    description: 'The synthetic fibers help add strength, durability and sweat-wicking capabilities to the wool fabric.',
    features: ['Strength', 'Durability', 'Sweat-Wicking'],
    showPercent: true
  }];
  var features = [{
    description: "Wool is nature's magic fabric: each strand is naturally crimped which creates insulation pockets that keep warm air in and let sweat out.",
    id: 'feature-mega-warm',
    image: "".concat(imageRoot, "story_a.jpg"),
    title: 'Mega Warm'
  }, {
    description: 'From the city to the trails, MegaFleece was designed to keep you outdoors even when the temperatures drop.',
    id: 'feature-mega-versatile',
    image: "".concat(imageRoot, "story_b.jpg"),
    title: 'Mega Versatile'
  }, {
    description: 'By using recycled wool, we can save water and chemicals and cut down on the overall impact of wool production.',
    id: 'feature-mega-vibes',
    image: "".concat(imageRoot, "story_c.jpg"),
    title: 'Mega Good <br />Earth Vibes'
  }];

  var props = _objectSpread(_objectSpread(_objectSpread({
    blends: blends,
    blendsTitle: 'Earth Friendly. Mega Fluffy.',
    cornerImage: "".concat(imageRoot, "oatmeal_detail_raw_final.jpg"),
    fabric: 'MegaFleece',
    features: features
  }, posterProps), videoProps), {}, {
    productItems: [{
      cta: 'Shop Now',
      fabric: 'MegaFleece',
      features: ["Women's", 'Available in five colors', 'Kangaroo pocket with secure internal storage', 'Wind-resistant lined hood', 'Upper arm zipper pocket for extra storage', 'Ribbed cuffs'],
      id: 'halfzip',
      image: "".concat(imageRoot, "product_halfzip_dijon.jpg"),
      items: [],
      title: 'Half-Zip Hoodie',
      url: '/products/megafleece-half-zip-hoodie'
    }, {
      fabric: 'MegaFleece',
      cta: 'Shop Now',
      features: ["Men's", 'Available in two colors', 'Kangaroo pocket with secure internal storage', 'Snap collar', 'Ribbed cuffs'],
      id: 'snapup',
      image: "".concat(imageRoot, "product_snapup_oatmeal.jpg"),
      items: [],
      title: 'Snap Up',
      url: '/products/megafleece-snap-up'
    }, {
      fabric: 'MegaFleece',
      cta: 'Shop Now',
      features: ["Women's", 'Available in two colors', 'Ribbed cuffs'],
      id: 'crewneck',
      image: "".concat(imageRoot, "product_crewneck_papaya.jpg"),
      items: [],
      title: 'Crewneck',
      url: '/products/megafleece-crewneck-1'
    }],
    productItemsTitle: 'The MegaFleece Collection'
  });

  ReactDOM.render( /*#__PURE__*/_jsx(ProductSpotlight, _objectSpread({}, props)), document.getElementById('page-megafleece'));
};

init();